/** `read` with each path read once; a failed read is forgotten so the next ask retries. */
export function memoised<T>(read: (path: string) => Promise<T>): (path: string) => Promise<T> {
  const cache = new Map<string, Promise<T>>()
  return (path) => {
    const cached = cache.get(path)
    if (cached) return cached
    const promise = read(path)
    cache.set(path, promise)
    promise.catch(() => cache.delete(path))
    return promise
  }
}
